import 'moment/locale/ca';
import 'moment/locale/es';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/fr';
import 'moment/locale/de';

import { initReactI18next } from 'react-i18next';
import { isDevelopmentMode } from '@utils/get-environment/constants';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import backend from 'i18next-http-backend';
import moment from 'moment-timezone';

import packageJson from '../package.json';

if (globalThis.window !== undefined && import.meta.env.MODE !== 'production') {
  globalThis.moment = moment;
}

const appVersion = packageJson.version;

const allNamespaces = [
  'common',
  'customers',
  'floorplan',
  'floorplanV2',
  'eventInfo',
  'eventList',
  'eventDetails',
  'offers',
  'publish',
  'menu',
  'errors',
  'addons',
  'presets',
  'passes',
  'analytics',
  'invitations',
  'eventReport',
  'bookingDetail',
  'selectVenue',
  'refundModal',
  'viewOnlyReportPage',
  'preRegistration',
  'userPermissions',
  'userManagement',
  'companySettings',
  'companyIntegrations',
  'companyWidget',
  'companyEventDefaults',
  'admissionGroups',
  'newVenue',
];

const i18nInitPromise = i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['ca', 'de', 'en', 'es', 'fr', 'it', 'pt'],
    debug: isDevelopmentMode,
    ns: allNamespaces,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'navigator'],
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json?lng={{lng}}&{{ns}}&v=${appVersion}`,
      requestOptions: {
        cache: 'no-store',
      },
    },
  })
  .then(() => i18n.loadNamespaces(allNamespaces));

export { i18nInitPromise };
export default i18n;
